import Typography from '@wearesection/bandai-react-components/atoms/Typography';
import {Box} from '@mui/material';
import {useRouter} from 'next/router';
import React from 'react';

type ITitleBlogFilter = {
  title: string;
  tagQuery: string;
  numberResult: number;
};

const TitleBlogFilter: React.FC<ITitleBlogFilter> = props => {
  const {title, tagQuery = 'All posts tagged “Dragon ball”', numberResult = 1} = props;
  const router = useRouter();
  return (
    <Box
      sx={{
        marginTop: {
          xs: '40px',
          md: '132px',
        },
      }}
    >
      {title && (
        <Typography color="#1E1E1E" variant="h1" textTransform={undefined}>
          {title}
        </Typography>
      )}

      {tagQuery && (
        <Typography
          color="#1E1E1E"
          variant="h5"
          textTransform={undefined}
          sx={{
            marginTop: {
              xs: '34px',
              md: '80px',
            },
          }}
        >
          {tagQuery}
        </Typography>
      )}

      {numberResult > 0 && (
        <Typography
          color="#737373"
          variant="p3"
          textTransform={undefined}
          sx={{
            marginTop: {
              xs: '6px',
              md: '15px',
            },
          }}
        >
          Showing {numberResult} posts
        </Typography>
      )}
    </Box>
  );
};

export default TitleBlogFilter;
